export function getParticipantMap() {
    return JSON.parse(localStorage.getItem('currentParticipantMap')) || {};
}

export function getParticipantForOwner(ownerId) {
    const participantMap = getParticipantMap();
    return participantMap[ownerId];
}

export function getParticipantsAsArray() {
    const participantMap = getParticipantMap();
    return Object.values(participantMap);
}

export function maybeSaveParticipantForOwner(ownerId, participantId) {
    let currentParticipantId = getParticipantForOwner(ownerId);
    if (currentParticipantId != null) {
        return;
    }
    let map = getParticipantMap();
    map[ownerId] = participantId;
    localStorage.setItem('currentParticipantMap', JSON.stringify(map));
}

export function deleteParticipantForOwner(ownerId) {
    let participantMap = getParticipantMap();
    delete participantMap[ownerId];
    localStorage.setItem(
        'currentParticipantMap',
        JSON.stringify(participantMap)
    );
}